







import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { Template } from '@/model/Template';

@Component
export default class TemplateContentLinkBadges extends Vue {

  @Prop()
  template: Template;

  @Prop()
  templateContentId: string;

  get isCreated(): boolean {
    return (this.template.createdTemplateContentIds || []).includes(this.templateContentId);
  }

  get isReported(): boolean {
    return (this.template.reportedTemplateContentIds || []).includes(this.templateContentId);
  }

  get anyContentHasBothBadges(): boolean {
    const reportedIds = this.template.reportedTemplateContentIds || [];
    return (this.template.createdTemplateContentIds || []).some(id => reportedIds.includes(id));
  }

}
